export type PostalMunicipality = {
  municipality: string;
  postCode: string;
  subMunicipality: string;
};

export type PostalStreet = {
  municipality: string;
  postCode: string;
  street: string;
};

export type PostalHouseNumber = PostalStreet & {
  houseNumber: string;
};

export type PostalBoxNumber = PostalHouseNumber & {
  boxNumber: string;
};
